var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRfidCardWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "60.000000pt",
    height: "40.000000pt",
    viewBox: "0 0 60.000000 40.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,40.000000) scale(0.100000,-0.100000)",
    fill: "white",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 388 c-17 -17 -17 -359 0 -376 17 -17 559 -17 576 0 17 17 17 359 0 376 -17 17 -559 17 -576 0z m568 -188 l0 -180 -280 0 -280 0 0 180 0 180 280 0 280 0 0 -180z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460 360 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500 360 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540 360 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69 281 c-25 -25 -29 -37 -29 -81 0 -44 4 -56 29 -81 26 -25 37 -29 86 -29 49 0 60 4 86 29 25 25 29 37 29 81 0 44 -4 56 -29 81 -43 43 -129 43 -172 0z m81 -11 c0 -17 -7 -20 -47 -20 -45 0 -46 0 -28 20 10 11 31 20 47 20 21 0 28 -5 28 -20z m82 3 c13 -12 18 -31 18 -71 0 -62 -18 -92 -57 -92 -22 0 -23 2 -23 90 0 86 1 90 22 90 12 0 30 -7 40 -17z m-82 -73 c0 -29 -2 -30 -45 -30 -43 0 -45 1 -45 30 0 29 2 30 45 30 43 0 45 -1 45 -30z m0 -70 c0 -15 -7 -20 -28 -20 -16 0 -37 9 -47 20 -18 20 -17 20 28 20 40 0 47 -3 47 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500 268 c26 -42 26 -104 0 -145 -11 -18 -15 -33 -10 -33 17 0 43 64 43 105 0 41 -26 105 -43 105 -5 0 -1 -15 10 -32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464 248 c9 -12 16 -36 16 -53 0 -17 -7 -41 -16 -53 -17 -25 -3 -30 16 -6 17 20 17 98 0 118 -19 24 -33 19 -16 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434 195 c0 -36 4 -51 10 -45 6 6 10 26 10 45 0 19 -4 39 -10 45 -6 6 -10 -9 -10 -45z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400 193 c0 -21 3 -24 9 -14 5 8 7 20 4 28 -8 21 -13 15 -13 -14z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRfidCardWhite);
export default __webpack_public_path__ + "static/media/rfidCardWhite.418ffd72c07ccd799df32e296943c509.svg";
export { ForwardRef as ReactComponent };